<template>
  <div class="container-fluid">
    <span class="resize-loading" v-if="!reseller">
      <span class="loader"></span>
    </span>
    <reseller-form
      v-if="reseller"
      :loading="loading"
      :resellerData="reseller"
      :formErrors="formErrors"
      @resellerSubmitted="handleSubmit"
      @formChanged="() => (alertLeave = true)"
    />
  </div>
</template>

<script>
import ResellerForm from "../partials/ResellerForm.vue";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";

export default {
  layout: "DashboardLayout",

  components: { ResellerForm },

  mixins: [alertLeave],

  props: {
    resellerId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      reseller: null,
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      this.loading = true;
      try {
        await this.$store.dispatch("resellers/get", this.resellerId);
        this.reseller = this.$store.getters["resellers/reseller"];
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: `Oops, something went wrong!`,
        });
        this.loading = false;
      }
    },

    async handleSubmit(reseller) {
      this.loading = true;
      const resellerData = cloneDeep(reseller);

      try {
        await this.$store.dispatch("resellers/update", resellerData);
        this.$notify({
          type: "success",
          message: this.$t("RESELLERS.RESELLER_UPDATED"),
        });
        const reseller = await this.$store.getters["resellers/reseller"];
        this.$emit("onViewReseller", reseller, true);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
